/**
 * Shared styles for variable/directive chips and picker lists.
 * Used by VariableTokenNodeView and floating suggestion panels; chip height
 * alignment (e.g. min-height for { and @ chips) can be added here.
 */

/** Outer chip container: simple variable and directive chips. min-height aligns { and @ chip height (directive chip has inner buttons). */
export const CHIP_CLASSES =
  "mx-0.5 min-h-[1.5rem] px-2 py-0.5 inline-flex cursor-pointer items-center rounded-sm bg-secondary text-sm text-secondary-foreground hover:bg-secondary/80";

/** Inner segment controls inside a directive chip (span with role=button to avoid native button min-height). */
export const SEGMENT_CLASSES =
  "inline-flex min-h-0 items-center leading-tight rounded-sm px-1 py-0.5 text-secondary-foreground";

/** Picker list (cmdk): floating suggestion panel (scroll/size only; panel chrome on wrapper). */
export const PICKER_LIST_FLOATING_CLASS =
  "z-50 max-h-[280px] min-w-[160px] overflow-auto py-1";

/** Picker list (cmdk): inside a dropdown panel popover (no border, transparent bg). */
export const PICKER_LIST_POPOVER_CLASS =
  "z-50 max-h-[280px] min-w-[160px] overflow-auto py-1";

/** Picker list (cmdk): inside a floating paper wrapper (no border/bg/scroll; wrapper provides them). */
export const PICKER_LIST_INSIDE_PAPER_CLASS = "min-w-[160px] py-1";
